import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class TooltipItemTitle extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tooltip__item_title',
            className,
        ];
    }

}

TooltipItemTitle.propTypes = propTypes;

TooltipItemTitle.defaultProps = defaultProps;

export default TooltipItemTitle;
